import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Seo } from '../types';
import { Meta, Title } from '@angular/platform-browser';
import basePath from '../utils/basePath';
import locationPath from '../utils/locationPath';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    readonly titlePrefix = 'Private Capital Indices';

    private _targetUrl = '';

    get url(): string {
        return basePath(this.location.path());
    }

    constructor(
        private meta: Meta,
        private title: Title,
        private location: Location
    ) {}

    get defaultSeo(): Seo {
        return {
            type: 'website',
            title: '',
            url: locationPath(this.url),
            description:
                'State Street private capital indices provide deep coverage of global private markets, delivering accurate, unbiased, timely benchmarks and customizable analytics built on verified cash flow and valuation data from the book-of-records at State Street.',
            keywords:
                'private capital index, private capital benchmark, private markets benchmark, private markets analytics, private equity index, private debt index, unbiased private asset benchmark, private equity performance data, institutional benchmark, custom benchmark, private fund quartile analysis, public market equivalent, cash flow pacing, J-curve, portfolio company holdings',
            imageUrl: locationPath('/research/dam/public/peindex/images/pci_seo_meta.png'),
            imageWidth: 1200,
            imageHeight: 630
        };
    }

    set targetUrl(url: string) {
        this._targetUrl = url;
    }

    get targetUrl() {
        return this._targetUrl;
    }

    updateMetaTags(seo: Seo): void {
        if (seo.type) {
            this.meta.updateTag({
                property: 'og:type',
                content: seo.type
            });
        }
        if (seo.url) {
            this.meta.updateTag({
                property: 'og:url',
                content: seo.url
            });
        }
        this.meta.updateTag({
            name: 'title',
            property: 'og:title',
            content: `${this.titlePrefix}${seo.title ? ` | ${seo.title}` : ''}`
        });
        if (seo.description) {
            this.meta.updateTag({
                name: 'description',
                property: 'og:description',
                content: seo.description
            });
        }
        if (seo.keywords) {
            this.meta.updateTag({
                name: 'keywords',
                property: 'og:keywords',
                content: seo.keywords
            });
        }
        if (seo.imageUrl) {
            this.meta.updateTag({
                name: 'image',
                property: 'og:image',
                content: seo.imageUrl
            });
        }
        // if (seo.imageWidth) {
        //     this.meta.updateTag({
        //         property: 'og:image:width',
        //         content: `${seo.imageWidth}`
        //     });
        // }
        // if (seo.imageHeight) {
        //     this.meta.updateTag({
        //         property: 'og:image:height',
        //         content: `${seo.imageHeight}`
        //     });
        // }
    }

    updateTitle(title?: string): void {
        this.title.setTitle(`${this.titlePrefix}${title ? ` | ${title}` : ''}`);
    }
}
